export default __webpack_public_path__ + "static/media/angle-down.e60cc718.svg";